module.exports = __webpack_public_path__ + "img/horizontal_6_2_9016.561a4063.png";